import { HeadMetatags } from 'routes/components/Layout'
import { PageType } from 'routes/Solutions/helpers'

export function SolutionHeadMetatag({ pageData }: { pageData: PageType }) {
  const { title, description } = pageData

  return (
    <HeadMetatags
      title={title}
      description={typeof description === 'string' ? description : undefined}
    />
  )
}
